import React, {useEffect, useState} from "react";
import logo from "../img/logo.png";
import bgImage from "../img/bgdavipay.png";
import loadingGif from "../img/loading.gif";
import {ArrowLeft, ChevronDown, CreditCard} from "lucide-react";
import sn from "../img/countries/sn.png";
import ml from "../img/countries/ml.png";
import gn from "../img/countries/gn.png";
import chad from "../img/countries/td.png";
import cm from "../img/countries/cm.png";
import ga from "../img/countries/ga.png";
import ci from "../img/countries/ci.png";
import tz from "../img/countries/tz.png";
import tg from "../img/countries/tg.png";
import bj from "../img/countries/bj.png";
import api, {API_URL} from "../utils/api";
import sha256 from "crypto-js/sha256";
import axios from "axios";
import {parse, stringify} from "qs";
import {toast_error} from "../utils/toast_helper";
import {ToastContainer} from "react-toastify";

// Identifiants du compte partenaire de démonstration.
// Ils proviennent de l'environnement de compilation (fichier `.env` local, non versionné).
// Voir `.env.example` pour la liste des noms attendus.
//
// /!\ LIMITE CONNUE ET ASSUMÉE : Create React App remplace littéralement chaque
// `process.env.REACT_APP_*` par sa valeur au moment du build. Ces valeurs restent donc
// présentes dans le bundle JavaScript servi publiquement. Les sortir du code source les
// retire du dépôt Git, PAS du navigateur du visiteur.
// La seule correction de fond est architecturale : le login et la signature doivent être
// calculés par un service serveur qui seul détient les secrets.
// Voir docs/13-DETTE-ET-RISQUES.md (C1, C3, C4).
const DEMO_PARTNER_EMAIL = process.env.REACT_APP_DEMO_PARTNER_EMAIL;
const DEMO_PARTNER_PASSWORD = process.env.REACT_APP_DEMO_PARTNER_PASSWORD;
const DEMO_SECRET_KEY = process.env.REACT_APP_DEMO_SECRET_KEY;
const DEMO_PLATEFORME_ID = process.env.REACT_APP_DEMO_PLATEFORME_ID;
const DEMO_X_API_KEY = process.env.REACT_APP_DEMO_X_API_KEY;

// URL de notification appelée par le CORE en fin de transaction. Doit désigner un
// endpoint contrôlé par DAVIPAY : les notifications portent des données de transactions
// réelles. Optionnelle — si elle est vide, `partnerCallbackUrl` n'est pas envoyé du tout
// (le CORE déclare le champ `string | null`).
const DEMO_CALLBACK_URL = process.env.REACT_APP_DEMO_CALLBACK_URL;

// Noms des variables absentes du build — noms uniquement, jamais de valeur.
const MISSING_DEMO_ENV = [
    ["REACT_APP_DEMO_PARTNER_EMAIL", DEMO_PARTNER_EMAIL],
    ["REACT_APP_DEMO_PARTNER_PASSWORD", DEMO_PARTNER_PASSWORD],
    ["REACT_APP_DEMO_SECRET_KEY", DEMO_SECRET_KEY],
    ["REACT_APP_DEMO_PLATEFORME_ID", DEMO_PLATEFORME_ID],
    ["REACT_APP_DEMO_X_API_KEY", DEMO_X_API_KEY],
].filter(([, value]) => !value).map(([name]) => name);


export function Demo() {

    const [selectedCountry, setSelectedCountry] = useState("SN");
    const [isLoading, setIsLoading] = useState(true);
    const [showContent, setShowContent] = useState(false);
    const [isCountryOpen, setIsCountryOpen] = useState(false);
    const [amount, setAmount] = useState("");
    const [paying, setPaying] = useState(false);
    const email = DEMO_PARTNER_EMAIL;
    const password = DEMO_PARTNER_PASSWORD;
    const secretKey = DEMO_SECRET_KEY;
    const plateformeId = DEMO_PLATEFORME_ID;
    const x_api_key = DEMO_X_API_KEY;

    const countries = [
        {
            id: "SN",
            name: "Sénégal",
            flag: sn,
            devise: 'XOF',
            state: true,
        },
        {
            id: "GN",
            name: "Guinée",
            flag: gn,
            devise: 'GNF',
            state: true,
        },
        {
            id: "CI",
            name: "Côte d’Ivoire",
            flag: ci,
            devise: 'XOF',
            state: true,
        },
        {
            id: "BJ",
            name: "Benin",
            flag: bj,
            devise: 'XOF',
            state: true,
        },
        {
            id: "TD",
            name: "Tchad",
            flag: chad,
            devise: 'XAF',
            state: false,
        },
        {
            id: "CM",
            name: "Cameroun",
            flag: cm,
            devise: 'XAF',
            state: false,
        },
        {
            id: "ML",
            name: "Mali",
            flag: ml,
            devise: 'XOF',
            state: false,
        },
        {
            id: "GA",
            name: "Gabon",
            flag: ga,
            devise: 'XAF',
            state: false,
        },
        {
            id: "TZ",
            name: "Tanzanie",
            flag: tz,
            devise: 'TZS',
            state: false,
        },
        {
            id: "TG",
            name: "Togo",
            flag: tg,
            devise: 'XOF',
            state: false,
        },
    ];

    const selectedCountryData = countries.find(country => country.id === selectedCountry);
    const isDisabled = !selectedCountryData?.state || !amount || parseInt(amount) < 100 || parseInt(amount) % 50 !== 0;

    function generateRandomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    const onSubmit = async () => {
        if (!isDisabled) {
            if (MISSING_DEMO_ENV.length > 0) {
                // Noms de variables uniquement : aucune valeur n'est journalisée.
                console.error(
                    "[DEMO] Build incomplet, variables d'environnement manquantes : " +
                    MISSING_DEMO_ENV.join(", ")
                );
                toast_error("La démonstration n'est pas configurée sur ce déploiement.");
                return;
            }
            setPaying(true);
            await api.post("auth/login", {email, password}).then(async (data) => {

                var today = new Date();
                today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
                const tokenToSend = sha256(secretKey + amount + today).toString();

                const defaults_direct_link = {
                    baseURL: API_URL,
                    headers: () => ({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${data.payload.token.accessToken}`,
                        'X-COUNTRY': selectedCountryData?.id,
                        'Token': tokenToSend,
                        'x-api-key': x_api_key,
                        'accept': '*/*',
                        // 'SERVIPROXY-API-KEY': getStoredAuthToken() ? `${getStoredAuthToken()}` : ''
                    }),
                    error: {
                        code: 'INTERNAL_ERROR',
                        message: 'Something went wrong. Please check your internet connection or contact our support.',
                        status: 503,
                        data: {},
                    },
                };
                const api_direact_link = (method, url, variables) =>
                    new Promise((resolve, reject) => {
                        axios({
                            url: `${defaults_direct_link.baseURL}${url}`,
                            method,
                            headers: defaults_direct_link.headers(),
                            params: method === 'get' ? variables : undefined,
                            data: method !== 'get' ? variables : undefined,
                            paramsSerializer: {
                                encode: parse,
                                serialize: stringify,
                            },
                        }).then(
                            response => {
                                resolve(response.data);
                            },
                            error => {
                                if (error.response) {
                                    reject(error.response.data.error);
                                } else {
                                    reject(defaults_direct_link.error);
                                }
                            },
                        );
                    });

                var idExt = today + '-' + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds() + generateRandomString(10);
                // console.log(idExt)

                var datatoSend = {
                    "montantPaye": parseInt(amount),
                    "paiementDate": today,
                    "plateformeId": plateformeId,
                    "idTransactionExt": idExt,
                    "commentaire": "",
                    "typeTransaction": "Merchand",
                    "redirectUrl": window.location.href
                }

                if (DEMO_CALLBACK_URL) {
                    datatoSend.partnerCallbackUrl = DEMO_CALLBACK_URL;
                }

                await api_direact_link('post', 'api/v1/gichet-unique-api/create-payment', datatoSend).then((data) => {
                    window.location.href = data.payload.paymentLink.toString();
                }).catch((error) => {
                    toast_error("Nous sommes temporairement indosponibles pour les tests...")
                    setTimeout(function () {
                        toast_error("Veuillez rééssayer plutard svp..")
                        setPaying(false);
                    }, 2000);
                });
            }).catch((error) => {
                toast_error("Nous sommes temporairement indIsponibles pour les tests...")
                setTimeout(function () {
                    toast_error("Veuillez rééssayer plutard svp..")
                    setPaying(false);
                }, 2000);
            });

        }
    }

    useEffect(() => {
        const loadingTimer = setTimeout(() => {
            setIsLoading(false);

            setTimeout(() => {
                setShowContent(true);
            }, 300);
        }, 3000);

        return () => clearTimeout(loadingTimer);
    }, []);

    // useEffect(() => {
    //     if (!countries.find(country => country.id === selectedCountry) || !countries.find(country => country.id === selectedCountry)?.state) {
    //         toast_error("Ce pays est temporairement indisponible..")
    //     }
    // }, [selectedCountry]);

    // Écran de loading
    if (isLoading) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        filter: 'blur(8px)',

                    }}
                ></div>

                <div className="absolute inset-0 bg-white/20 backdrop-blur-md"></div>

                <div className="relative z-10 animate-scale-in flex items-center justify-center">
                    <img
                        src={loadingGif}
                        alt="Loading..."
                        className="w-1/2 md:w-1/4"
                    />
                </div>
            </div>
        );
    }

    if (!isLoading && !showContent) {
        return (
            <div className="fixed inset-0 z-50 flex items-center justify-center animate-fade-out">
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundRepeat: 'no-repeat',
                        filter: 'blur(8px)'
                    }}
                ></div>

                <div className="absolute inset-0 bg-white/20 backdrop-blur-md"></div>

                <div className="relative z-10 animate-scale-out flex items-center justify-center">
                    <img
                        src={loadingGif}
                        alt="Loading..."
                        className="w-1/2 md:w-1/4"
                    />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="animate-fade-in">
                <div
                    className="bg-no-repeat min-h-screen md:h-screen bg-white flex flex-col"
                    style={{
                        backgroundImage: `url(${bgImage})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}
                >

                    <div className="relative h-screen flex flex-col">
                        <div className="flex flex-col items-center pt-4">
                            <div className="mb-2 animate-fade-in">
                                <img
                                    src={logo}
                                    alt="Davipay Logo"
                                    className="h-14 md:h-16 transition-transform hover:scale-105"
                                />
                            </div>
                            <p className="text-gray-500 mb-0 md:mb-8 animate-fade-in-delay">Paiement avec Davipay</p>
                        </div>

                        <div className="flex-1 flex flex-col items-center justify-center px-4">
                            <div
                                className="w-full max-w-md bg-white rounded-xl shadow-lg overflow-hidden animate-slide-up z-50">
                                <div className="bg-slate-800 text-white p-4">
                                    <button
                                        className="flex items-center justify-center space-x-2 transition-all hover:translate-y-1 w-full">
                                        {/*<ArrowDown size={20}/>*/}
                                        <CreditCard size={20}/>
                                        <span>Testez notre solution de paiement</span>
                                    </button>
                                </div>

                                <div className="p-6 space-y-6">
                                    <div className="relative">
                                        <label className="block text-sm text-gray-600 mb-2">Pays</label>
                                        <div className="relative">
                                            <button
                                                type="button"
                                                onClick={() => setIsCountryOpen(!isCountryOpen)}
                                                className={`w-full flex items-center justify-between p-3 border rounded-lg bg-white transition-all duration-300 ${
                                                    isCountryOpen ? 'border-blue-500 shadow-md' : 'border-gray-200 hover:border-gray-300'
                                                }`}
                                            >
                                                <div className="flex items-center space-x-3">
                                                    {selectedCountryData ? (
                                                        <>
                                                            <img
                                                                src={selectedCountryData.flag}
                                                                alt={selectedCountryData.name}
                                                                className="w-8 h-8 object-cover rounded-sm"
                                                            />
                                                            <span
                                                                className="text-gray-900">{selectedCountryData.name}</span>
                                                        </>
                                                    ) : (
                                                        <span className="text-gray-500">Sélectionnez un pays</span>
                                                    )}
                                                </div>
                                                <ChevronDown
                                                    className={`transition-transform duration-300 ${isCountryOpen ? 'rotate-180' : ''}`}
                                                    size={20}
                                                />
                                            </button>

                                            {/* Dropdown */}
                                            {isCountryOpen && (
                                                <div
                                                    className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 animate-in slide-in-from-top-2 duration-300 h-48 overflow-y-auto overflow-x-hidden">
                                                    {countries.map((country, index) => (
                                                        <button
                                                            key={country.id}
                                                            type="button"
                                                            onClick={() => {
                                                                setSelectedCountry(country.id);
                                                                setIsCountryOpen(false);
                                                            }}
                                                            className="w-full flex items-center space-x-3 p-3 text-left hover:bg-blue-50 transition-all duration-200 transform hover:scale-[1.02] first:rounded-t-lg last:rounded-b-lg border-b border-gray-100 last:border-b-0"
                                                            style={{animationDelay: `${index * 50}ms`}}
                                                        >
                                                            <img
                                                                src={country.flag}
                                                                alt={country.name}
                                                                className="w-6 h-6 object-cover rounded-sm"
                                                            />
                                                            <span className="text-gray-900">{country.name}</span>
                                                        </button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm text-gray-600 mb-2">Montant</label>
                                        <div
                                            className="flex items-center border rounded-lg overflow-hidden transition-all duration-300 hover:border-gray-300 focus-within:border-blue-500 focus-within:shadow-md">
                                            <input
                                                type="number"
                                                min={100}
                                                value={amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        onSubmit();
                                                    }
                                                }}
                                                className="text-2xl font-bold text-blue-600 focus:outline-none w-full px-3 py-3 transition-all duration-300"
                                            />

                                            <div
                                                className="border-l bg-gray-50 py-3 px-4 transition-colors duration-300">
                                                <span
                                                    className="text-gray-600 font-medium">{countries.find(country => country.id === selectedCountry)?.devise}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-xs text-gray-500 animate-fade-in-delay-2">
                                        <span className='text-red-500'>Note importante :</span> Veuillez noter que les
                                        tests
                                        de
                                        paiement sont réels ! votre comptemobile money seront réellement
                                        débités à hauteur du montant renseigné pendant le test. <br/>
                                        {amount && parseInt(amount) < 100 && (
                                            <div className="mt-1 text-center text-red-500 text-xs animate-fade-in">
                                                Le montant minimal est de 100 :)
                                            </div>
                                        )}
                                        {amount && parseInt(amount) > 100 && parseInt(amount) % 50 !== 0 && (
                                            <div className="mt-1 text-center text-red-500 text-xs animate-fade-in">
                                                Le montant doit etre multiple de 50 ;)
                                            </div>
                                        )}
                                        {!countries.find(country => country.id === selectedCountry) || !countries.find(country => country.id === selectedCountry)?.state
                                            && (
                                                <div className="mt-1 text-center text-red-500 text-xs animate-fade-in">
                                                    Ce pays est temporairement indisponible..
                                                </div>
                                            )}
                                    </div>
                                    <button
                                        disabled={isDisabled || paying}
                                        className={`w-full py-3 px-6 rounded-lg flex items-center justify-center space-x-2 transition-all duration-300 transform active:scale-95
                                         ${!isDisabled && !paying
                                            ? "bg-blue-600 hover:bg-blue-700 text-white hover:shadow-lg hover:scale-105"
                                            : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                                        onClick={() => onSubmit()}
                                    >
                                        {paying ? (
                                            <svg className="animate-spin h-5 w-5 mr-2 text-white"
                                                 xmlns="http://www.w3.org/2000/svg" fill="none"
                                                 viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10"
                                                        stroke="currentColor"
                                                        strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor"
                                                      d="M4 12a8 8 0 018-8v8z"></path>
                                            </svg>
                                        ) : null}
                                        {paying ? 'Veuillez patienter...' : 'Payer'}
                                        {paying ? null : <ArrowLeft
                                            className="transform rotate-180 transition-transform duration-300"
                                            size={20}
                                        />}
                                    </button>
                                </div>
                            </div>

                            <div
                                className="mt-6 flex items-center space-x-2 text-gray-500 text-sm animate-fade-in-delay-2">
                                <span>Sécurisé par</span>
                                <img src={logo} alt="DAVIPAY Security Logo"
                                     className="h-5 transition-transform hover:scale-110"/>
                            </div>
                        </div>

                    </div>

                    <footer className="mt-auto p-0 md:p-4 md:mr-56">
                        <div className="container mx-auto flex justify-between items-center md:px-24">
                            <div className="flex items-center text-blue-500 cursor-pointer" onClick={() => {
                                window.location.href = "https://davipay.org";
                            }}>
                                <ArrowLeft className="ml-1 md:mr-2 block sm:hidden" size={14}/>
                                <ArrowLeft className="mr-2 hidden sm:block" size={20}/>
                                <span className="text-sm md:text-md">Accéder à DAVIPAY</span>
                            </div>
                            <div className="text-sm md:text-md text-gray-500 mr-1 md:mr-0">{new Date().getFullYear()} ©
                                All rights reserved by
                                DAVIPAY
                            </div>
                            <div className="hidden md:block"></div>
                        </div>
                    </footer>
                </div>
            </div>
            <ToastContainer/>
        </React.Fragment>
    );
}